<template>
	<div>
		<!-- 顶部 -->
		<div class="header-body">
			<Button type="info" @click="add">添加</Button>
		</div>
		<Divider />
		<!-- table -->
		<Table :columns="columns" :data="data" border></Table>
		<!-- 分页 -->
		<div class="page-body">
			<Page :total="total" :current='page' @on-change="changePage" show-elevator show-total/>
		</div>
		
		<!-- 头像 -->
		<Modal v-model="addShow" title="添加头像" width="600" :mask-closable="false">
			<Form ref="formData" :model="formData" :label-width="80">
				<FormItem label="类型">
					<Select v-model="formData.type" placeholder="请选择头像类型" style="width: 200px;">
						<Option value="1">男</Option>
						<Option value="2">女</Option>
						<Option value="3">其他</Option>
					</Select>
				</FormItem>
				<FormItem label="头像">
					<Uploads v-if="addShow" :images="formData.url" @send-img="getImg"></Uploads>
				</FormItem>
			</Form>
			<div slot="footer">
				<Button type="default" @click="addShow = false;">取消</Button>
				<Button type="primary" @click="submit">提交</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
	import Uploads from '@/components/Uploads'
	import { getHeadImg, addHeadImg,deleteHeadImg } from '@/utils/wenxue.js'
	export default {
		name: 'Icon',
		components: {
			Uploads
		},
		data() {
			return {
				page:1,
				total:0,
				data: [],
				columns: [
					{
						title:'序号',
						width:80,
						align:'center',
						render:(h,param)=>{
							return h('span',{},param.index - 0 + 1)
						}
					},
					{
						title: '图标',
						minWidth: 150,
						align: 'center',
						render:(h,param)=>{
							return h('img',{
								attrs:{
									src:param.row.url
								},
								style:{
									width:'58px',
									height:'58px'
								}
							})
						}
					},
					{
						title:'类型',
						width:120,
						align:'center',
						key:'type_text'
					},
					{
						title: '操作',
						minWidth: 150,
						align: 'center',
						render: (h, param) => {
							var _that = this;
							return h('div', [
								h('Button', {
									props: {
										type: 'error',
										size: 'small'
									},
									style: {

									},
									on: {
										'click': function() {
											_that.$Modal.confirm({
												title: '删除确认',
												content: '该操作不可逆，是否确认删除？',
												onOk: function() {
													deleteHeadImg({
														id: param.row.id
													}).then(res => {
														let index = null;
														_that.data.forEach((e, key) => {
															if(e.id == res) {
																index = key;
															}
														})

														if(index !== null) _that.data.splice(index, 1);
													})
												}
											})
										}
									}
								}, '删除')
							])
						}
					}
				],
				addShow: false,
				formData: {
					url:[],
					type:1
				},
			}
		},
		methods: {
			changePage(page){
				this.getList(page);
			},
			async getList(page) {
				this.page = page;
				const param = {
					page:page || 1,
					page_num:10
				};
				
				const data = await getHeadImg({form:param});

				this.data = data['data'];
				this.total = data['total'];
			},
			add() {
				this.addShow = true;

				this.formData.url = [];
				this.formData.type = '1';
			},
			getImg(img) {
				this.formData.url = img;
			},
			submit() {
				if(this.formData.url.length == 0){
					this.$Message.warning('请上传图片');
					
					return false;
				}
				
				var _that = this;
				const param = {
					type:this.formData.type,
					url:this.formData.url[0]
				};
				
				addHeadImg({
					form: param
				}).then((res) => {
					_that.$Message.info('添加成功');
					_that.addShow = false;
					_that.getList();
				})
			},
		},
		mounted() {
			this.getList();
		}
	}
</script>

<style scoped>
	.ivu-layout {
		height: 100vh !important;
	}
	
	.header-body {
		width: 100%;
		min-height: 36px;
		display: flex;
		align-items: center;
	}
	
	.ivu-divider-horizontal {
		margin: 12px !important;
	}
	.page-body{
		width: 100%;
		height: 50px;
		display: flex;
		align-items: center;
		justify-content: flex-end;
		margin-top: 12px;
	}
</style>


// WEBPACK FOOTER //
// src/views/wenxue/Icon.vue